<template>
<modal name="editGroupModal" transition="pop-out" :width="modalWidth" :height="300">
  <div class="modal__header">
      <h4>Edit Competency Group</h4>
  </div>
  <div class="cas_input">
      <div class="row__wrapper">
          <div class="row">
            <div class="col-md-12">
                <div class="" style="width: 100%">
                    <span>Name</span>
                    <div class="input___group">
                        <input type="text" placeholder="Competency group name" class="ml-3" v-model="group.name" />
                    </div>
                </div>
            </div>
        </div>
      </div>
      
      <div class="text-center mt-4">
        <button class="creaet_branch_btn"
            @click="validateDetails($event)"
            :disabled="isButtonDisabled ? true : null"
            :style="[
            isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' }
            ]">
            Save Competency Group
            <span class="">
                <img src="@/assets/img/git_loader.gif" v-if="showLoader"  width="25px"/>
            </span>
        </button>
      </div>
  </div>
</modal>
</template>
<script>
const MODAL_WIDTH = 650;
import configObject from "@/config";

export default {
  name: 'editGroupModal',
  props: ["group"],
  data () {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled:  false,
      showLoader: false,
    }
  },
  created () {
    this.modalWidth = window.innerWidth < MODAL_WIDTH
      ? MODAL_WIDTH / 2
      : MODAL_WIDTH
  },
  mounted(){
      this.showLoader = false;
      this.isButtonDisabled = false;
  },
  methods: {
      validateDetails($event) {
        $event.preventDefault();
        if(!this.group.name){
            this.$toasted.show("Fill in the missing Fields", {
                    theme: "bubble",
                    position: "top-center",
                    duration: 2000
                });
        }else {
            this.editCompetencyGroup();
        }
    },
    cloaseModal(){
        this.$modal.hide('editGroupModal');
    },
    editCompetencyGroup() {
        let dataToSend = {
            name: this.group.name,
            id: this.group.id
        };
        this.showLoader = true;
        this.isButtonDisabled = true;
        this.axios.put(`${configObject.apiBaseUrl}/Competency/Group/Edit/${this.group.id}`, dataToSend, configObject.authConfig)
            .then((res) => {
                this.showLoader = false;
                this.isButtonDisabled = false;
                this.$eventHub.$emit("updateGroupTable");
                this.$toast.success("Competency Group editted successfully");
                this.cloaseModal();
                //this.getCompetencyGroups();
                })
                .catch((error) => {
                    this.isButtonDisabled = false;
                    this.showLoader = false;
                    let msg = "Unable to edit competency group";
                    if(error.response.data.message){
                        msg = error.response.data.message;
                    }

                    this.$toast.open({
                        message: msg,
                        type: "error",
                        duration: 4000
                    });
                    console.log(error.response.data.message);
            });
    },
    
  }
}
</script>
